<template>
  <div>
    <inline-form :company="company" :editable="editable">

      <template slot="fields">
        <label for="v-company-motto" class="cm-label">{{ I18n.t('activerecord.attributes.company.motto') }}</label>
        <autosize-textarea id="v-company-motto" type="text" class="cm-field" rows="1" v-model="company.motto" maxlength="85" />
      </template>

      <p class="motto" v-if="company.motto">{{ company.motto }}</p>
      <p class="motto motto--empty" v-else>{{ I18n.t('add_a_company_motto') }}</p>
    </inline-form>
  </div>
</template>

<script>
  import AutosizeTextarea from '../components/autosize-textarea'
  import InlineForm from './inline-form'

  export default {
    props: ['id', 'value', 'editable'],

    data: function () {
      return {
        company: {
          id: this.id,
          motto: this.value
        }
      }
    },

    components: {
      AutosizeTextarea,
      InlineForm
    }
  }
</script>

<style scoped lang="scss">
  .motto {
    &--empty {
      color: var(--fg-2);
    }
  }
</style>



// WEBPACK FOOTER //
// app/javascript/company/motto.vue?50243458